import * as types from './action-types';
import {getSearch, getPopularApps} from '../services/market-api';

export function searchIfNeeded(query) {
  return (dispatch, getState) => {
    const state = getState();

    if (state.search.query !== query) {
      dispatch(setQuery(query));
      return dispatch(fetchSearch(query, state.mode.lang));
    }
  };
}

export function setQuery(query) {
  return {
    type: types.SET_SEARCH_QUERY,
    query
  };
}

export function requestSearch(query) {
  return {
    type: types.REQUEST_SEARCH,
    query
  };
}

export function receiveSearch(json) {
  return {
    type: types.RECEIVE_SEARCH,
    items: json ? json.map(i => i) : [],
    receivedAt: json ? Date.now() : 0
  };
}

export function requestPopular() {
  return {
    type: types.REQUEST_POPULAR_APPS
  };
}

export function receivePopular(json) {
  return {
    type: types.RECEIVE_POPULAR_APPS,
    items: json.map(i => i),
    receivedAt: Date.now()
  };
}

function fetchSearch(query, lang) {
  return dispatch => {
    dispatch(requestSearch(query));

    return getSearch(query, lang)
      .then(json => dispatch(receiveSearch(json)))
      .catch(() => dispatch(receiveSearch()));
  };
}

export function fetchPopularAppsIfNeeded() {
  return (dispatch, getState) => {
    const state = getState();

    if (state.search.popular.length === 0) {
      dispatch(requestPopular());

      return getPopularApps(state.mode.lang)
        .then(json => dispatch(receivePopular(json)))
        .catch(() => dispatch(receivePopular([])));
    }
  };
}



// WEBPACK FOOTER //
// ./actions/search.js